import React, { useState, useEffect } from "react";
import { fetchOrderHistory } from "../helpers/orders";
import { ValidateResponse } from "../helpers/global";
import { Message } from "../../components/Message";
import { List } from "../../components/List";



export function AppOrdersHistory({ orderId, setTitle }) {

    const [state, setState] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        fetchOrderHistory(orderId).then((res) => {

            const response = ValidateResponse(res.data, 'history');

            if (response.status === 'error') {
                setError(response.message, response.status);
            }
            else {
                setState(response.history);
                setIsLoaded(true);
                setTitle(response.history.title);
            }
        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });

    }, [orderId, setTitle]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (state === undefined || state === null || Object.keys(state).length === 0) {
        return (<Message type="noData" />);
    }

    let columns = [
        { key: "date", label: "Datum", type: "date"},
        { key: "action", label: "Actie", type: "text" },
        { key: "message", label: "Omschrijving", type: "text" }

    ];

    return (
        <>
            <List
                columns={columns}
                data={state.process}
                identifier={"list"}
            />
        </>
    );
}